import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BodyComponent implements OnInit {

  prod = environment.production;

  constructor() { }

  ngOnInit(): void {
  }

  linkTeachers() {
    //ToDo
  }

  linkStudents() {
    //ToDo
  }

}
